// import { CommunicationSdkWeb } from "@goapptiv/communication-sdk-react-pkg";
import { Stack, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { CustomerDatabaseStore } from "../../../../store/main/CustomerDatabaseStore";
import { SDK_BASE_URL, SECURE_APP_CODE, SECURE_AUTH_TOKEN_KEY } from "../../../../base";
import { getDataKeyFromLocalStorage } from "../../../../common/utils/AuthToken";
import { baseUrlSDK } from "../../../../common/constants/constant";
import { FetchState } from "../../../../domain/models/fetch-state";



type Scheme = "http" | "https" ;

const CommunicationSDKDesktop = () => {
  const { decodeToken, userDetails, getUserDetails, userDetailsStatus } = CustomerDatabaseStore();
 

  useEffect(() => {
      decodeToken();
      getUserDetails();
  }, []);
    
    
    

    const accessToken = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";

  const appCode = getDataKeyFromLocalStorage(SECURE_APP_CODE);
  

  const getSchemeAndUrl = (
    apiUrl: string
  ): { scheme: Scheme; baseUrl: string } | null => {
    try {
      const url = new URL(apiUrl);
      if (url.protocol === "http:" || url.protocol === "https:") {
        return {
          scheme: url.protocol.replace(":", "") as Scheme,
          baseUrl: url.hostname,
        };
      }
      return null; 
    } catch (error) {
      console.error("Invalid URL", error);
      return null;
    }
  };

    


  return (
    <>
      {/* {userDetailsStatus === FetchState.SUCCESS ? (
        <CommunicationSdkWeb
          httpScheme={getSchemeAndUrl(SDK_BASE_URL)?.scheme ?? "https"}
          baseUrl={SDK_BASE_URL}
          userId={userDetails?.id}
          appCode={appCode.toString()}
          accessToken={accessToken.toString()}
        />
      ) : (
        <Stack
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"100%"}
          height={"100vh"}
        >
          <CircularProgress size={"8rem"} />
        </Stack>
      )} */}
    </>
  );
};

export default CommunicationSDKDesktop;
